import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import GeneralInformationImage from "src/modules/3rd-party-management/assets/images/general-information.svg";
import { Badge, Col, Label, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import LocalizedPhoneInput from "src/modules/3rd-party-management/components/LocalizedPhoneInput";

const GeneralInfo = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    const dateUtils = new DateUtils();

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const attrs = organizationData?.data?.attributes || {};

    // Company info
    const name = attrs.name;
    const status = attrs.status;
    const reg = attrs.identity?.handelsregister;
    const address = attrs.address;
    const contact = attrs.contactInformation;

    const naceCode = attrs.activities?.nace?.[0] || "—";

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('general-info')}
            className={activeAccordion === 'general-info' ? 'active' : ''}
            eventKey={'general-info'}
        >
            <Accordion.Header>
                <img
                    src={GeneralInformationImage}
                    alt=""
                />
                <span>
                    {t('Company Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Row className="g-3 mb-4">
                    <Col sm="12" className="mb-5">
                        <h5>
                            {name}
                            <Badge
                                className={`${status === "active" ? "bg-success" : "bg-secondary"} ms-2`}
                            >
                                {t(status)}
                            </Badge>
                        </h5>
                        <Row>
                            <Col md="6">
                                <dl>
                                    <Label>
                                        {t('Legal Form')}
                                    </Label>
                                    <p className="mb-2">{attrs.legalForm}</p>

                                    <Label htmlFor="naceCode">
                                        {t('NACE Code')}
                                    </Label>
                                    <p className="mb-2">{naceCode}</p>

                                    <Label>
                                        {t('Commercial Register')}
                                    </Label>
                                    <p className="mb-2">
                                        {reg?.register} {reg?.number} ({reg?.court})
                                    </p>

                                    <Label>{t('VAT Number')}</Label>
                                    <p className="mb-2">{attrs.vatNumber}</p>

                                    <Label>{t('Registration Date')}</Label>
                                    <p className="mb-2">
                                        {attrs.registrationDate && (
                                            dateUtils.convertDateToDate(
                                                attrs.registrationDate,
                                                INTERNATIONAL_DATE_FORMAT
                                            )
                                        )}
                                    </p>

                                    <Label>{t('Employees')}</Label>
                                    <p className="mb-2">{attrs.numberOfEmployees?.toLocaleString()}</p>
                                </dl>
                            </Col>
                            <Col md="6">
                                <dl>
                                    <Label>{t('Address')}</Label>
                                    <p className="mb-2">
                                        {address?.street} {address?.houseNumber}, {address?.postalCode} {address?.city},{" "}
                                        {address?.country}
                                    </p>

                                    <Label>{t('Website')}</Label>
                                    <p className="mb-2">
                                        {contact?.websites?.map((w, i) => (
                                            <a key={i} href={w} target="_blank" rel="noopener noreferrer">
                                                {w}
                                            </a>
                                        ))}
                                    </p>

                                    <Label>{t('Email')}</Label>
                                    <p className="mb-2">{contact?.emails?.join(", ")}</p>

                                    <Label>
                                        {t('Phone')}
                                    </Label>
                                    <p className="mb-2">
                                        {(contact?.phoneNumbers || []).map((numb) => {
                                            return (
                                                <p>
                                                    <LocalizedPhoneInput
                                                        readOnly={true}
                                                        inputClass="w-100"
                                                        disableInitialCountryGuess={false}
                                                        disableCountryGuess={false}
                                                        value={numb}
                                                    />
                                                </p>
                                            )
                                        })}
                                    </p>

                                    <Label>{t('Fax')}</Label>
                                    <p className="mb-2">
                                        {(contact?.faxNumbers || []).map((numb) => {
                                            return (
                                                <p>
                                                    <LocalizedPhoneInput
                                                        readOnly={true}
                                                        inputClass="w-100"
                                                        disableInitialCountryGuess={false}
                                                        disableCountryGuess={false}
                                                        value={numb}
                                                    />
                                                </p>
                                            )
                                        })}
                                    </p>
                                </dl>
                            </Col>
                        </Row>
                        <p>
                            <strong>{t('Signatory Rules')}:</strong> {attrs.signatoryRules}
                        </p>
                        <p className="text-muted">
                            {t('Last updated')}: {attrs.lastUpdate?.date && (
                                dateUtils.convertDateToDate(
                                    attrs.lastUpdate.date,
                                    INTERNATIONAL_DATE_FORMAT
                                )
                            )}
                        </p>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    GeneralInfo
)